// src/components/Modals/NotificationModal.jsx
import React, { useRef, useEffect, useState } from 'react';

const NotificationModal = ({
  isOpen,
  onClose,
  notificationEnabled,
  onConfirm
}) => {
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (isOpen && textRef.current) {
      // テキストが複数行かどうかを判定
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const isEnabling = !notificationEnabled;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-[80] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 active:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center rounded-full">
            <img
              src={isEnabling ? "./assets/static/PI_A-ON.png" : "./assets/static/PI_A-OFF.png"}
              className="h-6 w-6"
              alt={isEnabling ? "notification on" : "notification off"}
            />
          </div>

          <h3 className="text-lg font-bold text-gray-800">
            {isEnabling ? '変更通知をONにする' : '変更通知をOFFにする'}
          </h3>

          <p
            ref={textRef}
            className={`text-sm text-gray-600 mt-2 ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            {isEnabling
              ? '次回停止予定日に変更があった場合、LINEメッセージで通知します。'
              : '次回停止予定日の変更通知を停止します。'
            }
          </p>

          <div className="mt-12 flex gap-4">
            <button
              onClick={onClose}
              className="w-full bg-gray-200 text-gray-700 font-bold py-2 px-4 rounded-lg active:ux-bg-gray transition-colors"
            >
              戻る
            </button>
            <button
              onClick={onConfirm}
              className="w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg active:bg-gray-700 transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;